export const GTMEvents = {
    WALLET_FAILED: 'event_wallet_failed',
};
